var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#3E4E5D"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.2 4v3.11q0 .501.06.993t.156 1.004H8.55q.098-.512.156-1.004.06-.492.06-.992V4zm1.75 7.07a.9.9 0 0 0-.273-.658.95.95 0 0 0-.678-.272.9.9 0 0 0-.372.073 1 1 0 0 0-.303.199.9.9 0 0 0-.275.658.93.93 0 0 0 .275.663A.95.95 0 0 0 8 12a1 1 0 0 0 .378-.07.915.915 0 0 0 .572-.86",
  clipRule: "evenodd"
})));
export default SvgInfo;